const Home = () => (
  <div className="homepage">
    <h2>Welcome to our page!</h2>
    <div className="homepage-paragraphs">
      <p>
        Lorem ipsum odor amet, consectetuer adipiscing elit. Dapibus nisl porttitor habitasse
        lacinia vitae montes id. Porttitor senectus hendrerit molestie interdum sollicitudin vel.
        Donec aenean commodo blandit sapien facilisis potenti magna molestie. Libero orci magnis
        turpis facilisi turpis habitant mus amet. Sagittis quis pellentesque malesuada nullam
        fringilla. Nulla tellus parturient dictum posuere torquent nisi suscipit sit. Lacus
        curae eleifend mi potenti interdum blandit dictum augue litora.
      </p>
      <p>
        Varius cras mus ut id taciti feugiat potenti nulla. Fusce conubia convallis condimentum
        odio, taciti mollis. Ipsum interdum sollicitudin cubilia libero vivamus. Hendrerit
        vehicula commodo felis praesent netus laoreet. At interdum pharetra quisque nec feugiat
        id faucibus. Ad porta mollis in dis; praesent felis. Urna ultrices volutpat egestas
        scelerisque venenatis. Ultrices dui condimentum sodales consectetur nulla urna risus
        vivamus. Molestie at ex, egestas libero nostra et.
      </p>
    </div>
  </div>
);

export default Home;
